import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { PortableTextBlock } from '@portabletext/react';
import PortableText from '@/components/PortableText';
import Button from '@mui/material/Button';
import useTranslations from '@/hooks/useTranslations';
import ArrowForwardIcon from '@mui/icons-material/ArrowForwardRounded';
import {
  PRODUCT_WORKFLOW_CATEGORY_CARPI_ID,
  PRODUCT_WORKFLOW_CATEGORY_MINO_ID,
  PRODUCT_WORKFLOW_CATEGORY_VOLAR_ID,
} from '@/constants/global';

interface props {
  title: string;
  subtitle?: string;
  description?: PortableTextBlock[];
  viewItemLabel?: string;
  id?: string;
}

export default function ShowDescription({
  title,
  subtitle,
  description,
  viewItemLabel,
  id,
}: props) {
  const { t, locale } = useTranslations();

  const getProduct = (id: string) => {
    switch (id) {
      case PRODUCT_WORKFLOW_CATEGORY_CARPI_ID:
        return 'carpi';
      case PRODUCT_WORKFLOW_CATEGORY_MINO_ID:
        return 'mino';
      case PRODUCT_WORKFLOW_CATEGORY_VOLAR_ID:
        return 'mino';
    }
  };

  return (
    <Stack
      component={'article'}
      direction='column'
      sx={{
        p: 1,
        height: '100%',
        position: 'relative',
        overflow: 'auto',
      }}
    >
      <article
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
        }}
      >
        <header>
          {!!title && (
            <Typography
              variant='h6'
              sx={{
                fontWeight: 'bold',
                color: 'text.primary',
                mb: 0.5,
              }}
            >
              {title}
            </Typography>
          )}
          {!!subtitle && (
            <Typography
              variant='body1'
              sx={{
                color: 'text.primary',
              }}
            >
              {subtitle}
            </Typography>
          )}
          {!!description && (
            <Typography
              variant='body2'
              component='div'
              sx={{
                color: 'text.primary',
              }}
            >
              <PortableText blocks={description} />
            </Typography>
          )}
        </header>

        {viewItemLabel && id && (
          <footer style={{ marginTop: 'auto' }}>
            <Stack
              component={'article'}
              direction='row'
              sx={{
                justifyContent: 'flex-end',
                mt: 'auto',
                '& > button': {
                  borderRadius: 10,
                },
                position: 'sticky',
                top: 0,
                zIndex: 1,
              }}
            >
              <Button
                variant='text'
                color='primary'
                size='small'
                endIcon={<ArrowForwardIcon />}
                aria-label={viewItemLabel}
                onClick={() =>
                  window.open(
                    `https://www.orthosolid.com/${locale}/products/${getProduct(id)}`,
                    '_blank',
                    'noopener,noreferrer',
                  )
                }
              >
                {t('buttons.readMore')}
              </Button>
            </Stack>
          </footer>
        )}
      </article>
    </Stack>
  );
}
